import { useState } from 'react';
import type { CurrentUser } from '@wundo/client/auth.ts';
import { useProfileSave } from '@/lib/profileSave.ts';
import type { AgendaView } from './AgendaToolbar.tsx';

/**
 * Week or list. Choosing one in the toolbar also saves it as the default, so the
 * toolbar and the settings page never disagree; the local choice only spares
 * the switch a wait on the server.
 */
export function useAgendaView(user: CurrentUser | undefined) {
  const [chosenView, setChosenView] = useState<AgendaView | null>(null);
  const { save: saveProfile } = useProfileSave();

  const chooseView = (view: AgendaView) => {
    setChosenView(view);
    saveProfile({ agenda_default_view: view });
  };

  return {
    view: chosenView ?? user?.agenda_default_view ?? 'week',
    chooseView,
  };
}
